import { moment } from "../../../../../../../utils";

// :: Named color constants — เปลี่ยนสีที่นี่ที่เดียวได้เลย ::
const DOT_COLOR = {
  complete: "#52c41a", // สีเขียว (สำเร็จแล้ว)
  cancel: "#ff4d4f",  // สีแดง (ยกเลิก)
  overdue: "#8c8c8c", // สีเทา (ผ่านวันนัดแล้ว แต่ยังไม่สำเร็จ/ยกเลิก)
  upcoming: "#faad14", // สีเหลือง (นัดยังไม่ถึง)
};

// :: Lookup สำหรับ status ที่มีสีตายตัว ::
const STATUS_COLOR_MAP = {
  Complete: DOT_COLOR.complete,
  Cancel: DOT_COLOR.cancel,
};

/**
 * Determine the status info (color + label) for next appointment
 *
 * @param {object} record
 * @param {"Waiting"|"Complete"|"Cancel"|null} record.appointment_status
 * @param {moment.Moment|null} record.appointment_date_moment
 * @returns {{ color: string, label: string }}
 */
export const getAppointmentStatusInfo = (record) => {
  const { appointment_status: status, appointment_date_moment: apptMoment } = record;

  if (status === "Complete") {
    return { color: DOT_COLOR.complete, label: "เสร็จสิ้น" };
  }
  if (status === "Cancel") {
    return { color: DOT_COLOR.cancel, label: "ยกเลิก" };
  }

  const isPast = apptMoment?.isBefore(moment());
  return isPast
    ? { color: DOT_COLOR.overdue, label: "ผ่านมาแล้ว" }
    : { color: DOT_COLOR.upcoming, label: "รอการนัดหมาย" };
};

/**
 * Determine the status dot color for next appointment
 *
 * @param {object} record
 * @returns {string} HEX color string
 */
export const getAppointmentDotColor = (record) => {
  return getAppointmentStatusInfo(record).color;
};
